<template>
    <div>
        <modal v-show="show" :show-header="false">
            <div class="row text-center">
                <div class="col-md-12">
                    <h2>Do you want to continue your session?</h2>
                    <p>For security reasons, your session will time out in {{ timeRemaining }} seconds <br>unless you continue.</p>
                </div>
            </div>
            <div slot="footer" class="text-center" v-show="timeRemaining > 0">
                <button type="button" class="btn" v-on:click="$emit('continue')">Continue Session</button>
            </div>
        </modal>
    </div>
</template>

<script type="text/babel">
    import Modal from './modal.vue'

    export default {
        props: {
            show: {
                type: Boolean
            },
            timeRemaining: {
                type: Number
            }
        },

        components: {
            Modal
        }
    }
</script>
